import React from 'react';
import './css/share-code.css';
import bj from './image/bj4.png';

document.title = '总裁读书会';

// eslint-disable-next-line react/react-in-jsx-scope
const Menu2 = () => (
  <div className="menuBackground">
    {' '}
    <img src={bj} alt="bj4" />
  </div>
);

export default Menu2;
